import { Unsubscribe, onValue, ref } from 'firebase/database';
import { sortAndFilterSessions } from '../../Helpers/sortAndFilterSessions';
import { Session, SessionWithId } from '../../Models/session';
import { database } from '../firebase';

export const sessionsOnValue: (
    setSessions: (value: React.SetStateAction<SessionWithId[]>) => void,
) => Unsubscribe = (setSessions) => {
    try {
        const sessionsRef = ref(database, 'sessions');
        return onValue(sessionsRef, (snapshot) => {
            if (snapshot.exists()) {
                let newSessions: SessionWithId[] = [];

                snapshot.forEach((childSnapshot: any) => {
                    const sessionData: Session = childSnapshot.val();
                    newSessions.push({
                        id: childSnapshot.key,
                        session: sessionData,
                    });
                });

                newSessions = sortAndFilterSessions(newSessions);
                setSessions(newSessions);
            }
        });
    } catch (err) {
        throw err;
    }
};
